<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Synchronize Whatsapp Contacts</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/contacts">Contacts</router-link>
                  </li>
                  <li class="breadcrumb-item active">Synchronize Whatsapp Contacts</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- /Search Filter -->
          <!-- {{formContact}} -->
          <!-- {{selectedContact}} -->
          <form @submit.prevent="processSync">
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="focus-label">
                    License
                    <i class="text-danger">*</i>
                  </label>
                  <multiselect :class="'form-control'" v-model="selectedContact" id="ajax" label="license_name"
                    track-by="id" :placeholder="''" :multiple="true" open-direction="bottom" :custom-label="customLabel"
                    :options="contactOptions" :searchable="true" :loading="isLoading" :internal-search="false"
                    :close-on-select="false" :options-limit="300" :limit="3" :limit-text="limitText" :max-height="600"
                    :show-no-results="true" :hide-selected="true" @search-change="asyncFind" :show-labels="false">
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <span>{{ option.license_name + " (" + option.license_phone_number + ")" }}</span>
                        <span class="custom__remove" @click="remove(option)">❌</span>
                      </span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="selectedContact.length"
                        @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6">
                <div class="form-group">
                  <!-- {{formCreateContact}} -->
                  <label class="d-block">Group</label>
                  <div class="task-wrapper">
                    <div class="task-list-container">
                      <div class="task-list-body">
                        <a href="#" class="btn btn-primary btn-block" data-toggle="modal" data-target="#add_group">
                          <i class="fa fa-plus"></i> Add a new group
                        </a>
                        <div class="input-group ">
                          <span class="input-group-text" id="basic-addon1"><i class="fa fa-search"></i></span>
                          <input v-model="filter" type="text" class="form-control" placeholder="Group Name"
                            aria-label="Group Name" aria-describedby="basic-addon1">
                        </div>
                        <ul id="task-list">
                          <template v-for="rowG in groupListFilterArr">
                            <template>
                              <li v-on:click="selectGroup(rowG.id);" v-bind:id="rowG.id" class="task" :class="{
                                'completed': formContact.list_id.includes
                                  (rowG.id)
                              }" :key="rowG.id">
                                <div class="task-container">
                                  <span class="task-action-btn task-check">
                                    <span class="action-circle large complete-btn" title="Select">
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <span class="task-label" contenteditable="false">{{ rowG.name }}</span>
                                </div>
                              </li>
                            </template>
                          </template>
                          <!-- <template v-for="rowG in groupListArr">
                            <li
                              v-on:click="selectGroup(rowG.id);"
                              v-bind:id="rowG.id"
                              class="task"
                              :key="rowG.id"
                            >
                              <div class="task-container">
                                <span class="task-action-btn task-check">
                                  <span class="action-circle large complete-btn" title="Select">
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <span class="task-label" contenteditable="false">{{rowG.name}}</span>
                              </div>
                            </li>
                          </template> -->
                        </ul>
                        <strong><small v-if="formContact.list_id.length">Group Selected : {{ formContact.list_id.length }}</small></strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button @click.prevent="processSync" :disabled="isLoadingButton"
                    class="btn btn-primary submit-btn">Sync
                    Whatsapp</button>
                </div>
              </div>
              <div class="col-md-3"></div>
            </div>
          </form>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
    <create-group />
  </div>
</template>

<script>
import CreateGroup from "./createGroup.vue";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    CreateGroup,
    Multiselect
  },

  watch: {
    selectedContact: {
      handler: function (val, oldVal) {
        // console.log("val.id", val, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedLicense = val;
        }
        if (val.length == 1) {
          this.formContact.license_id = val[0].id;
        } else {
          this.formContact.license_id = "";
        }
      },
      deep: true
    }
  },
  data() {
    return {
      filter: '',
      isLoadingButton: false,
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      urlTemplate: process.env.VUE_APP_IC_URL,
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        list_id: []
      },
      loadingGroup: false,

      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      },
      formContact: {
        license_id: "",
        list_id: [],
        list_id_str: ""
      },
      loading: false
    };
    //  isactive : true
  },
  created() {
    this.asyncFind("");

    this.getGroupList();
    this.$root.$on("getGroupList", dataParams => {
      this.getGroupList(dataParams);
    });
  },
  beforeDestroy() {
    this.$root.$off("getGroupList");
  },
  filters: {
    labelPackageProduct(value) {
      return labelPackageProduct(value);
    }
  },
  computed: {
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    },
    groupListFilterArr() {
      // Jika input pencarian kosong, tampilkan semua item
      if (!this.filter.trim()) {
        return this.groupListArr;
      }
      // Jika tidak, filter item berdasarkan pencarian
      return this.groupListArr.filter(item => {
        // Menggunakan metode 'LIKE' untuk pencarian yang mirip
        return item.name.toLowerCase().includes(this.filter.toLowerCase());
      });
    },
  },
  methods: {
    async processSync() {
      this.isLoadingButton = await true;
      this.list_id_str = "";
      let newParam = {
        license_id: this.formContact.license_id,
        list_id: ""
      };
      if (this.formContact.list_id.length) {
        this.formContact.list_id.forEach((value, inx) => {
          newParam.list_id += value + ",";
        });
      }
      await this.$store
        .dispatch("contact/syncContactsCheck", newParam)
        .then(response => {
          this.$store
            .dispatch("contact/syncContactsProcess", newParam)
            .then(responseSync => {
              this.isLoadingButton = false;
              this.$fire({
                title: "Processing",
                text:
                  responseSync["msg"] + ". Total Data: " + responseSync["data"],
                type: "warning",
                timer: 3000
              }).then(r => {
                this.$router.push("/contacts");
              });
            }) // sesuai kan dengan method di API
            .catch(error => {
              this.isLoadingButton = false;
            });
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingButton = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ license_name, license_phone_number }) {
      return `${license_name} – ${license_phone_number}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.license_name = query;
      this.$store
        .dispatch("license/getLicenseList", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          console.log("query: ", query);
          console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAll() {
      this.selectedContact = [];
    },
    getWhatsappNumberFromJid(value) {
      return getWhatsappNumberFromJid(value);
    },
    labelStatusMessage(value) {
      return labelStatusMessage(value);
    },
    async getGroupList() {
      this.loadingGroup = await false;
      await this.$store
        .dispatch("contact/getGroupList", this.groupListParam) // sesuai kan dengan method di API
        .catch(error => {
          //   this.loading = false;
          this.loadingGroup = false;

          console.log("error", error);
        });
    },
    async selectGroup(id) {
      var element = document.getElementById(id);
      if (this.formContact.list_id.length > 0) {
        var isFound = false;
        var indexFound = -1;
        await this.formContact.list_id.forEach((value, index) => {
          if (value === id.toString()) {
            indexFound = index;
          }
        });

        if (indexFound >= 0) {
          element.classList.remove("completed");
          this.formContact.list_id.splice(indexFound, 1);
        } else {
          // this.$refs
          element.classList.add("completed");
          this.formContact.list_id.push(id.toString());
        }
      } else {
        element.classList.add("completed");
        this.formContact.list_id.push(id.toString());
      }
      console.log("seeleee", this.formContact.list_id);
    }
  },
  mounted() {
    // Date Time Picker
    setTimeout(() => {
       if(this.$route.query.group_id){
      let found = this.groupListArr.find(element => element.id == this.$route.query.group_id);
      if(found){
        this.selectGroup(found.id);
      }
    }
    }, 2000);
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "sync-contacts"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/sync-contact.vue